export default class AvoidMonstersState extends Phaser.State {
    create() {

    }
}
